import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.min.js";

class PdfUtil {
    static async getPdfPageCount(file) {

        const reader = new FileReader();

        return await new Promise((resolve, reject) => {
            reader.onload = async function (e) {
                const arrayBuffer = e.target.result;
                const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
                resolve(pdf.numPages);
            };
            reader.readAsArrayBuffer(file);
        });
    }
}

export default PdfUtil;
